module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notificationsPage d-flex flex-column"
  }, [_c('h2', {
    staticClass: "p-3 border-bottom-light"
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-sm-12 d-flex align-items-center justify-content-between my-3"
  }, [_c('div', {
    staticClass: "p-0"
  }, [_c('v-select', {
    attrs: {
      "value": _vm.selectedNotificationType,
      "label": "description",
      "options": _vm.notificationTypes
    },
    on: {
      "input": _vm.filterTypeChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('button', {
    staticClass: "btn action mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.askDeleteAllNotifications
    }
  }, [_vm._v("\n                    Delete all\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn tertiary mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.markAllNotificationsRead
    }
  }, [_vm._v("\n                    Mark all as read\n                ")])])])]), _vm._v(" "), (_vm.isLoadingNotifications) ? _c('div', {
    staticClass: "dark text-center"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "yScroll pb-3"
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex justify-content-end my-4"
  }, [(_vm.pageInfo && _vm.pageInfo.pageCount > 1) ? _c('uib-pagination', {
    attrs: {
      "total-items": _vm.pageInfo.totalItemCount,
      "items-per-page": _vm.pagination.pageSize,
      "boundary-link-numbers": false,
      "max-size": 7
    },
    on: {
      "change": function($event) {
        return _vm.paginationChanged()
      }
    },
    model: {
      value: (_vm.pagination),
      callback: function($$v) {
        _vm.pagination = $$v
      },
      expression: "pagination"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 my-4"
  }, _vm._l((_vm.currentNotifications), function(notification) {
    return _c('notification', {
      key: notification.id,
      staticClass: "border-bottom-medium",
      attrs: {
        "notification": notification
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex justify-content-end my-4"
  }, [(_vm.pageInfo && _vm.pageInfo.pageCount > 1) ? _c('uib-pagination', {
    attrs: {
      "total-items": _vm.pageInfo.totalItemCount,
      "items-per-page": _vm.pagination.pageSize,
      "boundary-link-numbers": false,
      "max-size": 7
    },
    on: {
      "change": function($event) {
        return _vm.paginationChanged()
      }
    },
    model: {
      value: (_vm.pagination),
      callback: function($$v) {
        _vm.pagination = $$v
      },
      expression: "pagination"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isLoadingNotifications) ? _c('div', {
    staticClass: "text-center w-100"
  }, [_c('loader')], 1) : (_vm.currentNotifications && _vm.currentNotifications.length < 1) ? _c('div', {
    staticClass: "text-center dark p-4"
  }, [_vm._v("\n            No notifications\n        ")]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6f2031d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f2031d8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/Notifications.vue
// module id = 1539
// module chunks = 0